import {
  AppState,
  Auth0Provider,
  Auth0ProviderOptions,
} from '@auth0/auth0-react'

import { PropsWithChildren } from 'react'
import { useNavigate } from 'react-router-dom'

export const Auth0ProviderWithRedirectCallback = ({
  children,
  ...props
}: PropsWithChildren<Auth0ProviderOptions>) => {
  const navigate = useNavigate()

  const onRedirectCallback = (appState: AppState) => {
    console.info('onRedirectCallback', appState)
    navigate(
      appState?.returnUrl || window.location.pathname + window.location.search,
      {
        state: { ...appState },
      }
    )
  }

  return (
    <Auth0Provider onRedirectCallback={onRedirectCallback} {...props}>
      {children}
    </Auth0Provider>
  )
}
